import { createSlice } from "@reduxjs/toolkit";

const emotionSlice = createSlice({
  name: "emotionAdd",
  initialState: {
    isEmotionAddOpen: false,
  },
  reducers: {
    toogleEmotionAdd: (state) => {
      state.isEmotionAddOpen = !state.isEmotionAddOpen;
    },
  },
});

export const { toogleEmotionAdd } = emotionSlice.actions;
export default emotionSlice.reducer;